import React from 'react';

import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import usePatientLists from '../../../lib/hooks/usePatientLists';
import PatientListsIndividualCard from './PatientListsIndividualCard';
import { AdminProgressBar } from '../../../components/AdminProgressBar';
import { AddPatientListDialog } from '../../../components/AddPatientListDialog';
const useStyles = makeStyles((theme) => ({
  progressBarContainer: {
    width: 214,
    marginRight: 25,
  },
  patientListCard: {
    cursor: 'pointer',
    color: theme.palette.admin.main,
    fontWeight: 'bold',
    marginRight: 25,
    width: 214,
    height: 50,
    padding: 0,
  },
  patientListCardMoreButton: {
    marginTop: -5,
    marginRight: -10,
    padding: 0,
  },
  commonCardStyle: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '20px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      marginBottom: '20px',
    },
  },
}));

const PatientListsCards = () => {
  const classes = useStyles();
  const { isLoading, isRefetching, data: dataObject, refetch } = usePatientLists();
  const { data: patientLists } = dataObject ?? [];

  return (
    <>
      {isLoading || isRefetching ? (
        <Box className={classes.progressBarContainer}>
          <AdminProgressBar style={{ margin: '20px auto 20px' }} />
        </Box>
      ) : (
        <>
          <Box className={classes.commonCardStyle}>
            {' '}
            {/* Wrapper with margin */}
            <AddPatientListDialog
              invisible={false}
              refetch={refetch}
            />
          </Box>
          {Boolean(patientLists && patientLists.length) &&
            patientLists.map((list, index) => {
              return (
                <PatientListsIndividualCard
                  listItem={list}
                  key={index}
                  refetch={refetch}
                />
              );
            })}
        </>
      )}
    </>
  );
};

export default PatientListsCards;
